import { Component, ViewChild, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { EmployeeService } from '../shared/services/employee.service';
import { v_EmployeeSearchBus } from '../shared/models/v_EmployeeSearchBus';
import { EmployeeReference } from '../shared/models/employeeReference';
import { EmployeeBus } from '../shared/models/EmployeeBus';
import { GItem } from '../shared/models/GItem';
import { PersonTradeSkillsBus } from '../shared/models/PersonTradeSkillsBus';
import { BaseAppMComponent } from '../shared/base-components/base-app-m.component';
import { AdditionalEmployeeData } from '../shared/models/AdditionalEmployeeData';
import { EmployeePage } from '../shared/models/EmployeePage';
import { GlobalsService } from '../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '../shared/enums/SaveMode';
import { PersonNotesBus } from '../shared/models/PersonNotesBus';
import { PersonBus } from '../shared/models/PersonBus';
import { CheckableSettings } from '@progress/kendo-angular-treeview';
import { AuthenticationService } from '../shared/services/authentication.service';
import { UsersBus } from '../shared/models/UsersBus.model';
import { TItem } from '../shared/models/TItem';
import { EmployeeBusInputParams } from '../shared/models/EmployeeBusInputParams';
import { trigger, transition, animate, style } from '@angular/animations';
import { FileRestrictions, SelectEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonFunctions } from '../shared/static/common-functions';
import { EmployHistoryBus } from '../shared/models/EmployHistory';
import { EmployHistoryComponent } from './employ-history/employ-history.component';
import { saveAs } from '@progress/kendo-file-saver';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { DepartmentsDialogComponent } from './domain-data/departments-dialog/departments-dialog.component';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { JobRolesDialogComponent } from './domain-data/job-roles-dialog/job-roles-dialog.component';
import { JobTitlesDialogComponent } from './domain-data/job-titles-dialog/job-titles-dialog.component';
import { SecJobRolesDialogComponent } from './domain-data/sec-job-roles-dialog/sec-job-roles-dialog.component';
import { CostCenterDialogComponent } from './domain-data/cost-center-dialog/cost-center-dialog.component';
import { UnionsDialogComponent } from './domain-data/unions-dialog/unions-dialog.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CmProAuthService } from '@app/core/services';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'employee',
    templateUrl: './employee.component.html',
    styleUrls: ['./employee.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))
            ])
        ])
    ]
})

export class EmployeeComponent extends BaseAppMComponent<EmployeeBus, EmployeeService, AdditionalEmployeeData, EmployeePage> implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    searchActive: boolean = true;
    employeePhoto: any;
    hasPhoto: boolean = false;
    photoInfo: FileInfo[] = [];
    selectedFeatureUser: string = '';
    selectedTemplate: string = '';
    loadingThings: boolean = false;
    dataLoading: boolean = false;
    employeeSearch: boolean = false;
    appCode: string = "Employee";
    public enableCheck = true;
    public checkChildren = true;
    public checkParents = true;
    public checkOnClick = false;
    public checkMode: any = 'multiple';
    public selectionMode: any = 'single';
    public copyFeatures: boolean = false;
    newEmployee: boolean = true;
    readOnlyToolTipMessage = 'This feature is read only. You must submit a request with IT to add or remove this feature.';

    @ViewChild('departmentsDialog') public departmentsDialog: DepartmentsDialogComponent;
    @ViewChild('jobRolesDialog') public jobRolesDialog: JobRolesDialogComponent;
    @ViewChild('jobTitlesDialog') public jobTitlesDialog: JobTitlesDialogComponent;
    @ViewChild('secJobRolesDialog') public secJobRolesDialog: SecJobRolesDialogComponent;
    @ViewChild('costCenterDialog') public costCenterDialog: CostCenterDialogComponent;
    @ViewChild('unionsDialog') public unionsDialog: UnionsDialogComponent;

    vaccines = [
        { value: "Pfiz", description: "Pfizer-BioNTech" },
        { value: "Moderna", description: "Moderna" },
        { value: "Johnson", description: "Johnson & Johnson" }
    ];

    constructor(globals: GlobalsService,
        featureFlagService: FeatureFlagService,
        svc_data: EmployeeService,
        svc_auth: AuthenticationService,
        qry_rd: DQOIReferenceDataQuery,
        private cd: ChangeDetectorRef,
        private sanitizer: DomSanitizer,

        private authService: CmProAuthService) {

        super(globals, featureFlagService, qry_rd);
        this.svc_data = svc_data;
        this.svc_auth = svc_auth;
        this.addtlDataClass = "AdditionalCustomerData";
        this.pageData = new EmployeePage(svc_data);
        this.saveMode = SaveMode.individual;
    }

    EditEmployeeInfo: boolean;
    ManagedSSN: string = '';
    ManagedDOB: string | Date = '';

    public get checkableSettings(): CheckableSettings {
        return {
            checkChildren: this.checkChildren,
            checkParents: this.checkParents,
            enabled: this.enableCheck,
            mode: this.checkMode,
            checkOnClick: this.checkOnClick
        };
    }

    override ngOnInit() {
        super.ngOnInit();
        this.loadingThings = true;
        this.refreshRefference();
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
                this.ManagedSSN = this.setManagedSSN();
                this.ManagedDOB = this.setManagedDOB();
                this.EditEmployeeInfo = this.rights.MaintainEmployeeInfo;
            }
        });
    }

    private setManagedDOB() {
        if (this.data?.person?.birthday && this.rights && this.rights.ViewEmployeeSecureInformation) {
            return new Date(this.data.person.birthday);
        }
        return '';
    }

    private setManagedSSN() {
        if (this.data && this.rights && this.rights.ViewEmployeeSecureInformation) {
            return this.data.ssnClear;
        }
        if (this.data && this.data.ssnClear) { return "*****" + this.data.ssnClear.slice(5); }
        else { return ""; }
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.authService.unsubscribeToLoginEvents();
        this.cleanupPreviews();
        CommonFunctions.unsubscribe(this.subs_data);
    }

    createForm(): UntypedFormGroup {

        return new UntypedFormGroup({
            'employeeId': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            //    'FirstName': new FormControl('', [Validators.required, Validators.maxLength(10)]),// InitCodeValidators.isNotDuplicate]),
            'firstName': new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
            'middleName': new UntypedFormControl('', Validators.maxLength(50)),
            'lastName': new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
            'legalName': new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
            'address1': new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
            'address2': new UntypedFormControl('', Validators.maxLength(100)),
            'city': new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
            'state': new UntypedFormControl('', Validators.required),
            'zip': new UntypedFormControl('', Validators.maxLength(20)),
            'birthday': new UntypedFormControl('', Validators.maxLength(20)),
            'contactEmail': new UntypedFormControl('', Validators.maxLength(100)),
            'emailPersonal': new UntypedFormControl('', Validators.maxLength(100)),
            'timekey': new UntypedFormControl('', Validators.maxLength(100)),
            'empNo': new UntypedFormControl('', Validators.maxLength(100)),
            'ssn': new UntypedFormControl('', [Validators.maxLength(50)]),
            'companyId': new UntypedFormControl(),
            'companyBranchId': new UntypedFormControl(),
            'baseUnionId': new UntypedFormControl(),
            'jobRoleId': new UntypedFormControl(),

            'poapprLimit': new UntypedFormControl(0),
            'isActive': new UntypedFormControl(),
            'userActive': new UntypedFormControl(),
            'hasMobile': new UntypedFormControl(),
            'jobTitle': new UntypedFormControl(),
            'jobTitlesId': new UntypedFormControl(),
            'mainNumber': new UntypedFormControl(),
            'cellNumber': new UntypedFormControl(),
            'personalPhone': new UntypedFormControl(),
            'skillRating': new UntypedFormControl(),
            'secJobRoleId': new UntypedFormControl(),
            'trade': new UntypedFormControl(),
            'costCenter': new UntypedFormControl('', Validators.required),
            'dlnbr': new UntypedFormControl(),
            'dlexpire': new UntypedFormControl(),
            'dlstate': new UntypedFormControl(),
            'hasCreditCard': new UntypedFormControl(false),
            'creditCard': new UntypedFormControl(), //last 4
            'epanbr': new UntypedFormControl(),
            'i9verified': new UntypedFormControl(false),
            'requireClockInOut': new UntypedFormControl(false),
            'managerId': new UntypedFormControl('', Validators.required),
            'userId': new UntypedFormControl(),
            'password': new UntypedFormControl(),
            'forceReset': new UntypedFormControl(false),
            'departmentId': new UntypedFormControl(),
            'baseCompany': new UntypedFormControl(),
            'termDt': new UntypedFormControl(),
            'hasSalary': new UntypedFormControl(),
            'hourlyRate': new UntypedFormControl(),
            'ohRate': new UntypedFormControl(),
            'overScale': new UntypedFormControl(),
            'ohPerct': new UntypedFormControl(),
            'commission': new UntypedFormControl(),
            'spOh': new UntypedFormControl(),
            'commissionProgram': new UntypedFormControl(),
            'overheadRate': new UntypedFormControl(),
            'overheadCost': new UntypedFormControl(),
            'overheadPercent': new UntypedFormControl(),
            'commissionPercent': new UntypedFormControl(),
            'specialOverheadRate': new UntypedFormControl(),
            'commissionCustomers': new UntypedFormControl([]),
            'co': new UntypedFormControl([]),
            'onStockReplenishment': new UntypedFormControl([]),
            'covidVaccinationDate': new UntypedFormControl([]),
            'covidVaccinationNotVaccinated': new UntypedFormControl([]),
            'covidBoosterDate': new UntypedFormControl([]),
            'covidBoosterNotVaccinated': new UntypedFormControl([]),
            'covidSecondVaccinationDate': new UntypedFormControl([]),
            'covidVaccinationBrand': new UntypedFormControl([]),
            'covidSecondVaccinationBrand': new UntypedFormControl([]),
            'covidBoosterVaccinationBrand': new UntypedFormControl([]),
            'sCpin': new UntypedFormControl([]),
            'hasShiftDifferential': new UntypedFormControl(),
            'shiftDifferential': new UntypedFormControl(),
            'shiftDifferentialOT': new UntypedFormControl(),
            'creditMemoApprLimit': new UntypedFormControl([]),
            'payrollCompanyCodeId': new UntypedFormControl(),
        });

    }

    public editForm: UntypedFormGroup = this.createForm();

    setForm() {
        if (this.compFeatureFlagSet.featureFlagSet['employee-phone-numbers-required']) {
            this.editForm.controls['mainNumber'].setValidators(this.getPhoneNumberValidators());
            this.editForm.controls['cellNumber'].setValidators(this.getPhoneNumberValidators());
            this.editForm.controls['personalPhone'].setValidators(this.getPhoneNumberValidators());
        }
        var cc = CommonFunctions.getArrayFromCommaDelimitedString(this.data.commissionCustomers);
        var tradeStr = "";
        if (this.data.person.trade) { tradeStr = this.data.person.trade.toString(); }
        this.editForm.patchValue({
            employeeId: this.data.employeeId,
            personId: this.data.personId,
            firstName: this.data.person.firstName,
            co: this.data.person.co,
            lastName: this.data.person.lastName,
            middleName: this.data.person.middleName,
            legalName: this.data.person.legalName,
            address1: this.data.person.address1,
            address2: this.data.person.address2,
            city: this.data.person.city,
            state: this.data.person.state,
            zip: this.data.person.zip,
            birthday: new Date(this.data.person.birthday),
            contactEmail: this.data.person.contactEmail,
            emailPersonal: this.data.person.emailPersonal,
            timekey: this.data.person.timekey,
            empNo: this.data.person.empNo,
            ssn: this.ManagedSSN,
            companyId: this.data.person.companyId,
            companyBranchId: this.data.person.companyBranchId,
            baseUnionId: this.data.person.baseUnionId,
            jobRoleId: this.data.person.jobRoleId,
            departmentId: this.data.person.departmentId,
            poapprLimit: this.data.person.poapprLimit,
            isActive: this.data.person.isActive,
            hasMobile: this.data.person.hasMobile,
            jobTitle: this.data.person.jobTitle,
            jobTitlesId: this.data.person.jobTitlesId,
            mainNumber: this.formatPhoneNumberDigits(this.data.person.mainNumber),
            cellNumber: this.formatPhoneNumberDigits(this.data.person.cellNumber),
            personalPhone: this.formatPhoneNumberDigits(this.data.person.personalPhone),
            skillRating: this.data.person.skillRating,
            trade: this.data.person.trade,
            costCenter: this.data.person.costCenter,
            dlnbr: this.data.person.dlnbr,
            dlexpire: new Date(this.data.person.dlexpire),
            dlstate: this.data.person.dlstate,
            hasCreditCard: this.data.person.hasCreditCard,
            creditCard: this.data.person.creditCard,
            epanbr: this.data.person.epanbr,
            i9verified: this.data.person.i9verified,
            requireClockInOut: this.data.person.requireClockInOut,
            managerId: this.data.person.managerId,
            secJobRoleId: this.data.person.secJobRoleId,
            termDt: CommonFunctions.getDate(this.data.person.termDt),
            commissionProgram: this.data.commissionProgram,
            commissionCustomers: cc,
            hourlyRate: this.data.hourlyRate,
            userId: null,
            password: '',
            onStockReplenishment: this.data.person.onStockReplenishment,
            forceReset: false,
            hasSalary: this.data.hasSalary,
            overheadRate: this.data.overheadRate,
            overheadCost: this.data.overheadCost,
            overScale: this.data.overScale,
            payrollCompanyCodeId: this.data.payrollCompanyCodeId,
            overheadPercent: this.data.overheadPercent,
            commissionPercent: this.data.commissionPercent,
            specialOverheadRate: this.data.specialOverheadRate,
            covidVaccinationDate: CommonFunctions.getDate(this.data.person.covidVaccinationDate),
            covidVaccinationNotVaccinated: this.data.person.covidVaccinationNotVaccinated,
            covidBoosterDate: CommonFunctions.getDate(this.data.person.covidBoosterDate),
            covidBoosterNotVaccinated: this.data.person.covidBoosterNotVaccinated,
            covidSecondVaccinationDate: CommonFunctions.getDate(this.data.person.covidSecondVaccinationDate),
            covidVaccinationBrand: this.data.person.covidVaccinationBrand,
            covidSecondVaccinationBrand: this.data.person.covidSecondVaccinationBrand,
            covidBoosterVaccinationBrand: this.data.person.covidBoosterVaccinationBrand,
            sCpin: this.data.person.sCpin,
            creditMemoApprLimit: this.data.person.creditMemoApprLimit,
            hasShiftDifferential: this.data.hasShiftDifferential,
            shiftDifferential: this.data.shiftDifferential,
            shiftDifferentialOT: this.data.shiftDifferentialOT,
        });
        this.filterJobRoles(this.data.person.baseUnionId, this.data.person.jobRoleId);
    }

    closeWindow() {
        this.data.person.firstName = null;

    }

    setData() {
        //    let busObj: EmployeeBus = this.editForm.value;
    }

    public svc_data: EmployeeService;
    public svc_auth: AuthenticationService;

    @ViewChild("cpEmployeeHistory") cpEmployeeHistory: EmployHistoryComponent;

    @ViewChild('employeeTabStrip') public employeeTabStrip: TabStripComponent;

    subs_data_search: Subscription;
    subs_template_search: Subscription;
    subs_data_ref: Subscription;
    subs_waivers: Subscription;
    subs_data: Subscription;
    searchValue: string = '';
    items: v_EmployeeSearchBus[] = [];
    id: any = null;
    data: EmployeeBus;
    originalData: EmployeeBus;
    userData: UsersBus;
    assignedUserFeatures: GItem[] = [];
    employeeReferenceData: EmployeeReference = new EmployeeReference();
    branches: GItem[] = null;
    unions: GItem[] = null;
    payrollCompanyCodes: GItem[] = null;
    jobRoles: GItem[] = null;
    filteredJobRoles: GItem[] = null;
    unionJobRoles: GItem[] = null;
    secTemplates: GItem[] = null;
    tradeSkills: GItem[] = [];
    availableUserFeatures: TItem[] = [];
    myFiles1: Array<FileInfo> = [];

    readOnly: boolean = true;

    get hasData(): boolean {
        return this.data !== undefined && this.data !== null;
    }

    get canEdit(): boolean {
        return this.readOnly && this.hasData;
    }

    get canClear(): boolean {
        return this.readOnly && this.hasData;
    }

    clear() {
        this.data = new EmployeeBus(); //new EmployeeBus();
        this.readOnly = true;
        this.editForm.reset();
        this.assignedUserFeatures = [];
        if (this.employeeTabStrip) {
            this.employeeTabStrip.selectTab(0);

        }
        this.filterJobRoles(null, null);
    }

    filterJobRoles(unionId: any, currentId: any) {
        if (unionId && unionId.value) {
            unionId = unionId.value;
        }
        var jobRoles = _.cloneDeep(this.jobRoles);
        var roleIds = this.unionJobRoles?.filter(a => a.category == unionId).map(a => a.value) ?? [];
        var filteredJobRoles = _.cloneDeep(jobRoles.filter(function(el) {
            return roleIds.indexOf(el.value) >= 0;
        }));

        // .filter(a => roleIds.indexOf(a.value) >= 0)
        if (currentId && roleIds.indexOf(currentId) < 0) {
            var additems = _.cloneDeep(jobRoles.filter(a => a.value == currentId));
            if (additems.length > 0) {
                additems[0].canSelect = false;
                filteredJobRoles.push(additems[0]);
            }
        }
        this.filteredJobRoles = filteredJobRoles.sort((a, b) => a.description.localeCompare(b.description));
    }

    public itemDisabledUnionRole(itemArgs: { dataItem: any; index: number; }) {
        return (itemArgs.dataItem.canSelect == false);
    }

    new() {
        this.clear();

        this.data.person = new PersonBus();
        this.data.employeeId = '00000000-0000-0000-0000-000000000000';
        this.data.personId = '00000000-0000-0000-0000-000000000000';
        this.data.person.personId = '00000000-0000-0000-0000-000000000000';
        this.data.person.userId = '00000000-0000-0000-0000-000000000000';
        this.data.person.companyId = this.globals.companyId;
        this.data.person.co = 1;
        this.data.person.isActive = true;

        this.setForm();
        this.data.person.firstName = "New Employee";
        this.newEmployee = true;
        this.assignedUserFeatures = [];
        this.employeePhoto = null;
        this.hasPhoto = false;
        this.edit();
        if (this.employeeTabStrip) {
            this.employeeTabStrip.selectTab(0);

        }
    }

    edit() {
        this.readOnly = false;
    }

    save() {
        this.loadingThings = true;
        let user = this.globals.user;
        let inputParams: EmployeeBusInputParams = new EmployeeBusInputParams();
        let busObj: EmployeeBus = new EmployeeBus(this.data);
        busObj.setFromForm(this.editForm.value);
        //fix ssn if blacked out
        if (busObj.ssn && busObj.ssn.length > 0 && busObj.ssn.substr(0, 1) == "*") {
            busObj.ssn = busObj.ssnClear;
        }
        busObj.setBeforeSave();
        busObj.person.mainNumber = this.phoneNumberDigitsOnly(busObj.person.mainNumber);
        busObj.person.cellNumber = this.phoneNumberDigitsOnly(busObj.person.cellNumber);
        busObj.person.personalPhone = this.phoneNumberDigitsOnly(busObj.person.personalPhone);
        let dateNow: Date = new Date(Date.now());
        if (busObj.hasId) {
            busObj.updateDt = dateNow;
            busObj.person.updateDt = dateNow;
            busObj.person.updateUserId = user.userid;
            busObj.updateUserId = user.userid;
            busObj.insertDt = this.data.insertDt;
            busObj.insertUserId = this.data.insertUserId;
            busObj.person.userId = this.data.person.userId;
            busObj.person.insertDt = this.data.person.insertDt;
            busObj.person.insertUserId = this.data.person.insertUserId;
        }
        else {
            busObj.insertDt = dateNow;
            busObj.person.insertDt = dateNow;
        }
        if (CommonFunctions.hasValue(this.cpEmployeeHistory)) {
            inputParams.employHistory = _.cloneDeep(this.cpEmployeeHistory.getChanged());
            inputParams.addDeletedItems(this.cpEmployeeHistory.getDeletedItems());
        }

        busObj.person.tradeSkills = [];
        this.tradeSkills
            .filter(s => s.category == true) // Using the category field to indicate selection
            .forEach(function(s, i) {
                let bus = new PersonTradeSkillsBus();
                bus.personId = busObj.personId;
                bus.tradeSkillId = s.value;
                bus.updateDt = dateNow;
                bus.updateUserId = user.userid;
                busObj.person.tradeSkills.push(bus);
            });
        inputParams.employeeData = busObj;
        inputParams.userData = new UsersBus();
        inputParams.userData.userid = busObj.person.userId || '00000000-0000-0000-0000-000000000000';
        inputParams.userData.updateDt = dateNow;
        inputParams.userData.updateUserId = user.userid;

        inputParams.userData.username = this.editForm.value.userId;
        inputParams.userData.pass = this.editForm.value.password;
        inputParams.userData.isactive = this.editForm.value.userActive;
        inputParams.userData.forcePasswordReset = this.editForm.value.forceReset;
        inputParams.userFeatures = this.assignedUserFeatures;
        this.svc_data.save(inputParams).subscribe(
            data => {
                this.SaveEmployeeSuccess(data);
                this.setPristine();
            },
            err => { this.CallFailed(err); }
        );
    }

    SaveEmployeeSuccess(data: any) {

        this.loadingThings = false;
        if (!data.saveError) {
            this.id = data.primaryId;
            this.savePhoto();

            this.getData(this.photoInfo.length <= 0);
            this.saveSuccess();
            this.newEmployee = false;
        }
        else {

            this.saveError(data.message);
        }
    }

    CallFailed(err) {
        this.loadingThings = false;
        this.saveError(err);
    }

    saveNote(e: any) {
        let user = this.globals.user;

        if (!this.data) {
            this.closeNote();
            return;
        }
        let busObj: PersonNotesBus = new PersonNotesBus();
        busObj.note = this.editNoteForm.controls["note"].value;
        busObj.personId = this.data.personId;
        busObj.personNotePersonId = user.personId;
        busObj.insertUserid = user.userid;
        busObj.updateUserId = user.userid;
        this.svc_data.saveNote(busObj).subscribe(data =>
            this.noteSaved(data, busObj)

        );
        this.closeNote();
    }

    get PersonId() {
        if (!this.data) {
            return '00000000-0000-0000-0000-000000000000';
        }
        return this.data.personId;
    }

    get EmployeeId() {
        if (!this.data) {
            return '00000000-0000-0000-0000-000000000000';
        }
        return this.data.employeeId;
    }

    noteSaved(data: any, note: PersonNotesBus) {
        let user = this.globals.user;
        this.saveSuccess();

        note.updateDt = new Date();
        this.data.person.notes.push(note);
        this.data.person.notes = this.data.person.notes.slice(0);
        this.data.person.notes.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            var c: any = new Date(a.updateDt);
            var d: any = new Date(b.updateDt);
            return d - c;
        });
    }

    cancel() {
        this.data = _.cloneDeep(this.originalData);
        this.setForm();
        // this.readOnly = true;
        this.cd.detectChanges();
    }

    companyBranchEnabled: boolean = true;
    baseUnionEnabled: boolean = true;
    jobRoleEnabled: boolean = true;

    refreshRefference() {

        if (this.subs_data_ref !== undefined && this.subs_data_ref !== null) {
            this.subs_data_ref.unsubscribe();
        }
        this.subs_data_ref = this.svc_data.GetReferenceData().subscribe(data => {
            this.employeeReferenceData = new EmployeeReference(data);
            this.employeeReferenceData.incentivePrograms = [{ value: null, description: "", category: null, reference: null }].concat(this.employeeReferenceData.incentivePrograms);
            this.branches = _.cloneDeep(this.employeeReferenceData.branches);
            this.unions = _.cloneDeep(this.employeeReferenceData.unions);
            this.jobRoles = _.cloneDeep(this.employeeReferenceData.jobRoles);
            this.unionJobRoles = _.cloneDeep(this.employeeReferenceData.unionJobRoles);
            this.secTemplates = _.cloneDeep(this.employeeReferenceData.secTemplates);
            this.tradeSkills = _.cloneDeep(this.employeeReferenceData.tradeSkills);
            this.svc_data.trainingCategories = _.cloneDeep(this.employeeReferenceData.trainingCategories);
            this.availableUserFeatures = _.cloneDeep(this.employeeReferenceData.userFeatures);
            this.payrollCompanyCodes = _.cloneDeep(this.employeeReferenceData.payrollCompanyCodes);
            this.availableUserFeatures.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
            this.assignedUserFeatures = [];
            this.loadingThings = false;
        });
    }

    getData(getPhotoOrPass: boolean = true) {
        if (!this.id) {
            return null;
        }
        this.hasPhoto = false;
        this.employeePhoto = null;
        this.loadingThings = true;
        this.svc_data.getById(this.id).subscribe(data => {
            this.data = data;
            //try to set these here as well due to race condition with user being loaded
            this.ManagedSSN = this.setManagedSSN();
            this.ManagedDOB = this.setManagedDOB();
            let arr = [];
            if (this.data.person && this.data.person.employHistory) {
                if (CommonFunctions.hasArrayValue(this.data.person.employHistory)) {
                    for (let i = 0; i < this.data.person.employHistory.length; i++) {
                        let newObj: EmployHistoryBus = new EmployHistoryBus(this.data.person.employHistory[i]);
                        arr.push(newObj);
                    }
                }
                this.data.person.employHistory = arr;
            }
            this.originalData = _.cloneDeep(data);
            this.setForm();

            this.tradeSkills.forEach(s => {
                let tskill = data.person.tradeSkills.find(t => t.tradeSkillId == s.value);
                s.category = tskill != null;
            });
            this.newEmployee = false;
            if (getPhotoOrPass) { this.getEmplyeePhoto(); }
            this.LoadTraining();
            this.LoadEmployeeDocuments();
            this.GetUserSecurity();
            if (this.canEdit) { this.edit(); }
        });
    }

    public LoadEmployeeDocuments() {
        if (this.EmployeeId == '00000000-0000-0000-0000-000000000000') { return; }
        this.svc_data.getEmployeeDocuments(this.EmployeeId).subscribe(
            data => this.retrieveEmployeeDocumentSuccess(data),
            err => { this.CallFailed(err); });
    }

    retrieveEmployeeDocumentSuccess(data: any) {
        this.svc_data.EmployeeDocumentData = data;
    }

    public LoadTraining() {
        if (this.PersonId == '00000000-0000-0000-0000-000000000000') { return; }
        this.svc_data.getPersonTraining(this.PersonId).subscribe(
            data => this.retrieveTrainingSuccess(data),
            err => { this.CallFailed(err); });
    }

    retrieveTrainingSuccess(data: any) {
        this.svc_data.EmployeeTrainingData = data;
    }

    importUserFeatureData(uid: string) {
        this.svc_auth.userFeatures(uid).subscribe(
            data => { this.ImportUserFeaturesSuccess(data); },
            err => { this.CallFailed(err); });
    }

    ImportUserFeaturesSuccess(data: any) {
        this.assignedUserFeatures = _.cloneDeep(data);
        this.loadingThings = false;
    }

    empSearchFC(filter: any) {
        if (!filter || filter.length == 0) {
            this.items = [];
            return;
        }
        if (this.subs_data_search !== undefined && this.subs_data_search !== null) {
            this.subs_data_search.unsubscribe();
        }
        this.subs_data_search = this.svc_data.search(filter, this.searchActive).subscribe(data => {
            this.items = data;
        });

    }

    empSearchVC(value: string) {
        if (value !== undefined && value !== null && value > "") {
            this.id = value.substring(200);
            this.getData();
            if (this.employeeTabStrip) {
                this.employeeTabStrip.selectTab(0);

            }
        }
    }

    employeeSelected(value: any) {

        this.employeeSearch = false;
        if (value != null) {

            this.id = this.compFeatureFlagSet.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"] ? value.employeeId : value.EmployeeId;
            this.getData();
            if (this.employeeTabStrip) {
                this.employeeTabStrip.selectTab(0);
            }
        }
        else {
            this.employeeSearch = false;
        }
    }

    featureImportSearchVC(value: string) {
        this.selectedFeatureUser = value.substring(200);

        this.svc_data.employeeUserFeatures(this.selectedFeatureUser).subscribe(
            data => { this.ImportUserFeaturesSuccess(data); },
            err => { this.CallFailed(err); });
    }

    featureImportTemplateVC(value: string) {
        this.selectedTemplate = value;

        this.svc_data.templateUserFeatures(this.selectedTemplate).subscribe(
            data => { this.ImportUserFeaturesSuccess(data); },
            err => { this.CallFailed(err); });
    }

    companyChanged(e: any) {
        if (e == undefined) {
            this.companyBranchEnabled = false;
            this.branches = [];
            this.unions = [];
        }
        else {
            this.companyBranchEnabled = true;
            this.branches = this.employeeReferenceData.branches.filter((s) => s.category === e);
            this.unions = this.employeeReferenceData.unions.filter((s) => s.category === e);
        }
    }

    branchChanged(e: any) {

    }

    unionChanged(e: any) {
        var jobRoleId = this.editForm.controls["jobRoleId"].value;
        this.filterJobRoles(e, jobRoleId);
    }

    activeNote: boolean = false;

    addNote() {
        this.editNoteForm.patchValue({
            note: ''
        });
        this.activeNote = true;
    }

    cancelNote(e: any) {
        this.closeNote();
    }

    closeNote() {
        this.activeNote = false;
    }

    public editNoteForm: UntypedFormGroup = new UntypedFormGroup({
        'note': new UntypedFormControl('', [Validators.required]),
    });

    public clearBaseUnionId() {

        this.editForm.patchValue({

            baseUnionId: null
        });
    }

    public GetUserSecurity() {

        this.assignedUserFeatures = [];
        if (!this.originalData) {
            return;
        }
        let uid = this.originalData.person.userId;

        this.svc_auth.userInfo(uid).subscribe(data => {

            if (data != null) {
                this.userData = _.cloneDeep(data);
                this.editForm.patchValue({

                    userId: this.userData.username,
                    password: this.userData.pass,
                    userActive: this.userData.isactive,
                    forceReset: this.userData.forcePasswordReset
                });

            }

            this.loadingThings = false;

        });

        this.svc_auth.userFeatures(uid).subscribe(data => {
            this.assignedUserFeatures = _.cloneDeep(data);
        });
    }

    public onTabSelect(e) {
        switch (e.index) {
            case 0: break;
            case 1: break;
            case 2: break;
            case 3: break;
        }
    }

    IsSelected(featureId: string) {
        return this.assignedUserFeatures.findIndex(f => f.value == featureId) >= 0;
    }

    IsFeatureGroupTotal(groupId: string) {
        let self = this;
        let group = this.availableUserFeatures.find(f => f.value == groupId);
        let features = group.items;
        let isPartial = features.length;
        features.forEach(function(f, i) {
            let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
            if (n >= 0) {
                isPartial--;
            }
        });
        return isPartial == 0;
    }

    IsFeatureGroupPartial(groupId: string) {
        let self = this;
        let group = this.availableUserFeatures.find(f => f.value == groupId);
        let features = group.items;
        let isPartial = features.length;
        features.forEach(function(f, i) {
            let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
            if (n >= 0) {
                isPartial--;
            }
        });
        return isPartial > 0 && isPartial < features.length;
    }

    SelectFeatrueGroup(e: any, groupId: string) {
        e.stopPropagation();
        let group = this.availableUserFeatures.find(g => g.value == groupId);
        if (!group) {
            return;
        }
        let self = this;
        let features = group.items;
        if (e.checked) {
            features.forEach(function(f, i) {
                let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
                if (n < 0) {
                    self.assignedUserFeatures.push(new GItem(f));
                }
            });
        }
        else {
            features.forEach(function(f, i) {
                let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
                if (n >= 0) {
                    self.assignedUserFeatures.splice(n, 1);
                }
            });
        }
    }

    SelectFeatrueGroup2(e: any, ep: any, groupId: string) {
        this.setDirty();
        e.stopPropagation();
        let group = this.availableUserFeatures.find(g => g.value == groupId);
        if (!group) {
            return;
        }
        let self = this;
        let features = group.items;
        if (ep.checked) {
            features.forEach(function(f, i) {
                let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
                if (n < 0 && f.canSelect) {
                    self.assignedUserFeatures.push(new GItem(f));
                }
            });
        }
        else {
            features.forEach(function(f, i) {
                let n = self.assignedUserFeatures.findIndex(ff => ff.value == f.value);
                if (n >= 0 && f.canSelect) {
                    self.assignedUserFeatures.splice(n, 1);
                }
            });
        }
    }

    SelectFeature(e: any, groupId: string, featureId: string) {
        this.setDirty();
        let n = this.assignedUserFeatures.findIndex(f => f.value == featureId);
        if (n >= 0 && !e.checked) {
            this.assignedUserFeatures.splice(n, 1);
        }
        else if (n < 0 && e.checked) {
            let grp = this.availableUserFeatures.find(f => f.value == groupId);
            if (grp) {
                let ftr = grp.items.find(f => f.value == featureId);
                if (ftr) {
                    this.assignedUserFeatures.push(new GItem(ftr));
                }
            }
        }
    }

    showFeatureCopyPanel() {
        this.copyFeatures = !this.copyFeatures;
    }

    public events: string[] = [];
    public imagePreviews: any[] = [];
    public uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.jpg', '.png']
    };

    public clearEventHandler(): void {
        this.photoInfo = [];
    }

    public savePhoto() {
        if (this.photoInfo.length <= 0) {
            return;
        }
        this.svc_data.uploadPhoto(this.photoInfo, this.PersonId).subscribe(
            data => this.photoSaved(data),
            err => { this.CallFailed(err); });
    }

    photoSaved(data: any) {
        this.getEmplyeePhoto();
    }

    public removeEventHandler(e: RemoveEvent): void {
    }

    getEmplyeePhoto() {
        this.hasPhoto = false;
        let self = this;
        this.svc_data.getEmployeePhoto(this.data.personId).subscribe(data => {
            if (data.documentB64String != null && data.documentB64String.length > 0) {
                self.employeePhoto = this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64," + data.documentB64String);
                self.hasPhoto = true;
            }
        });
    }

    public selectEventHandler(e: SelectEvent): void {
        this.hasPhoto = false;
        this.photoInfo = e.files;

        const file = e.files[0];

        if (!file || file.validationErrors) {
            return;
        }

        try {
            const previewUrl = URL.createObjectURL(file.rawFile);
            this.employeePhoto = previewUrl;

            const image = {
                src: previewUrl,
                uid: file.uid
            };

            this.imagePreviews = [image];
            this.hasPhoto = true;
        } catch (error) {
            this.hasPhoto = false;
        }
        this.setDirty();
        this.myFiles1 = [];
    }

    private cleanupPreviews(): void {
        if (this.employeePhoto && typeof this.employeePhoto === 'string' &&
            this.employeePhoto.startsWith('blob:')) {
            URL.revokeObjectURL(this.employeePhoto);
            this.employeePhoto = null;
        }

        if (this.imagePreviews[0]?.src?.startsWith('blob:')) {
            URL.revokeObjectURL(this.imagePreviews[0].src);
        }
        this.imagePreviews = [];
        this.hasPhoto = false;
    }

    refreshRefferenceData(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            this.refreshRefference();
        }
    }

    getEmployeeExport() {
        this.svc_data.getEmployeeExport(this.searchActive).subscribe(data => {
            var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var fileURL = URL.createObjectURL(file);
            saveAs(fileURL, "EmployeeExport.xlsx");
        });
    }

    getEmployeeExportCon() {
        this.svc_data.getEmployeeExportCon(this.searchActive).subscribe(data => {
            var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var fileURL = URL.createObjectURL(file);
            saveAs(fileURL, "EmployeeExportCon.xlsx");
        });
    }

    formatPhoneNumber(phoneNumber: string, phoneType) {
        if (!phoneNumber) {
            return;
        }
        phoneNumber = this.phoneNumberDigitsOnly(phoneNumber);
        var formattedPhoneNum = phoneNumber.substring(0, 3);

        if (phoneNumber.length >= 4 && phoneNumber.length < 7) {
            formattedPhoneNum = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3, 6);
        }

        if (phoneNumber.length >= 7) {
            formattedPhoneNum = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, 10);
        }

        switch (phoneType) {
            case 'main':
                if (formattedPhoneNum != this.editForm.controls.mainNumber.value) {
                    this.editForm.controls.mainNumber.setValue(formattedPhoneNum);
                }
                break;
            case 'cell':
                if (formattedPhoneNum != this.editForm.controls.cellNumber.value) {
                    this.editForm.controls.cellNumber.setValue(formattedPhoneNum);
                }
                break;
            case 'personal':
                if (formattedPhoneNum != this.editForm.controls.personalPhone.value) {
                    this.editForm.controls.personalPhone.setValue(formattedPhoneNum);
                }
                break;
            default:
                console.log('Unknown phone type');
                break;
        }
    }

    getPhoneNumberValidators() {
        if (!this.readOnly || this.EditEmployeeInfo) {
            return [Validators.required, Validators.maxLength(12), Validators.minLength(12), Validators.pattern("[0-9\-]{12}")];
        } else {
            return null;
        }
    }

    private formatPhoneNumberDigits(phoneNumber) {
        if (!phoneNumber) {
            return phoneNumber;
        } else {
            phoneNumber = phoneNumber.replace(/\D/g, "");
            phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }

        return phoneNumber;
    }

    private phoneNumberDigitsOnly(phoneNumber) {
        if (!phoneNumber) {
            return phoneNumber;
        } else {
            phoneNumber = phoneNumber.replace(/\D/g, "");
        }
        return phoneNumber;
    }
}
